import { render, staticRenderFns } from "./DataRoleU.vue?vue&type=template&id=4ee12a18&scoped=true"
import script from "./DataRoleU.vue?vue&type=script&lang=js"
export * from "./DataRoleU.vue?vue&type=script&lang=js"
import style0 from "./DataRoleU.vue?vue&type=style&index=0&id=4ee12a18&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee12a18",
  null
  
)

export default component.exports